import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  user: {},
  token: null,
  isLogged: false,
  currentProduct: null,
  currentProductData: {},
  userPhotoUrl: ''
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
}
